/**************************************************
 * Nombre:       TarjetaOferta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {ArrowForward, FiberManualRecord, School} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useNavigate} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../App";


const TarjetaOferta = ({item, index}) => {
    const cData = useContext(contexApp)
    const navigate = useNavigate();
    const [programas, setProgramas] = useState([])


    useEffect(() => {

        if (cData.programas.length > 0) {

            let arr = cData.programas.filter((t) => t.idEscuela === item.id)

            setProgramas(arr)
        }

    }, [cData, item])

    return (
        <Grid
            key={index}
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderColor: '#00000020',
                p: 4,
                overflow: 'hidden',
            }}

        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 2}}>


                <Typography sx={{
                    fontSize: 32,
                    fontWeight: 600,
                    fontFamily: NEGRITA,
                    lineHeight: 1.1
                }}>
                    <School sx={{fill: theme.palette.primary.main, pr: 2, width: 36, height: 36, mt: 0.6, mb: -0.6}}/>
                    {item.nombre}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                {programas.map((it, index) => (
                    <Grid
                        key={index + 's66'}
                        container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1.5}}>
                        <Typography
                            onClick={() => navigate('/Formacion/' + it.nombre.replaceAll(' ', '-'))}
                            sx={{
                                lineHeight: 1.2,
                                cursor: 'pointer',
                                transition: "all .2s ease-in-out",
                                '&:hover': {
                                    fontWeight: 600,
                                    textDecoration: 'underline',
                                }
                            }}>

                            <FiberManualRecord
                                sx={{fill: theme.palette.primary.main, width: 18, height: 18, mt: 0.5, mb: -0.5}}/>
                            {it.nombre}</Typography>
                    </Grid>
                ))}

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>

                <IconButton
                    onClick={() => navigate('/Escuela/' + item.nombre.replaceAll(' ', '-'))}
                    sx={{backgroundColor: theme.palette.primary.main}}>
                    <ArrowForward sx={{fill: '#fff', height: 18, width: 24}}/>
                </IconButton>
                <Button
                    onClick={() => navigate('/Escuela/' + item.nombre.replaceAll(' ', '-'))}
                    variant={'text'} sx={{pl: 1}}>Ver Detalles</Button>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mr: -8, mb: -4, mt: -8}}>
                <img src={item.img} width={'60%'} height={'auto'}/>
            </Grid>

        </Grid>
    )

}
export default TarjetaOferta